// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"472":"cc63f016","728":"282496d8","748":"9e2e4f06"}[chunkId] + ".chunk.css";
};